<template>
  <div class="update_sku">
    <div class="update_sku__header">
      <h4 class="title">
        {{ translate('device.sku.changing_device_sku') }}
      </h4>
    </div>


    <div class="content">
      <div class="type">
        <tree-select
            :options="device_sku_list"
            :multiple="false"
            v-model="new_device_sku"
            :placeholder="translate('device.device_sku')"
            :clearable="false"
            :searchable="true"
        />
      </div>
    </div>

    <div class="text-center">
      <button
          v-show="check_save"
          class="btn btn-success btn-fill btn-wd marginButton"
          @click.prevent="update_skus"
      >
        {{ translate('btn.edit') }}
      </button>
      <button
          class="btn btn-danger btn-fill btn-wd marginButton"
          @click.prevent="close"
      >
        {{ translate('btn.close') }}
      </button>

    </div>
  </div>
</template>

<script>

export default {
  name: "UpdateDeviceSku",
  props: [
    "device_fid",
    "device_sku"
  ],

  data () {
    return {
      new_device_sku: null
    }
  },

  computed:{
    check_save(){
      if (this.new_device_sku){
        const dev_sku_label = this.device_sku_list.find(item =>{
          return item.id === this.new_device_sku
        }).label
        return dev_sku_label !== this.device_sku
      }
      return false

    },
    device_sku_list() {
      return this.$store.getters.getDeviceSkus.map((sku) => {
        return {id: sku.id, label: sku.title}
      })
    }
  },

  created() {
    if (!this.device_sku) return null
    this.new_device_sku = this.device_sku_list.find(item =>{
      return item.label === this.device_sku
    }).id
  },

  methods: {
    update_skus(){
      this.$http.v1.updateDeviceSku(this.device_fid, {device_sku_id: this.new_device_sku}, (response) => {
        this.new_contacts = response.data
        this.$emit("update")
      });
    },

    close(){
      this.$emit("close")
    }
  },

}
</script>

<style lang="scss" scoped>
.update_sku{
  padding: 10px;
  &__header{
    .title{
      margin: 10px;
      text-align: center;
    }
  }
  .content{
    height: 300px;
    overflow-y: auto;
  }
}

</style>
